export default __webpack_public_path__ + "static/media/99_mobile.a737a284.jpg";